import React, { Fragment } from "react";
import Header from "../components/Header";
import PageHeader from "../components/PageHeader";
import Downloads from "../components/360ViewsMedia";
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";

const Views = () => {
  return (
    <Fragment>
      <Header />
      <PageHeader
        bgImg={require("../assets/img/downloads-bg.jpg")}
        title="Our Hospitals Tour - 360°"
        content=""
      />
      <Downloads />
      <Footer />
      <MobileMenu />
    </Fragment>
  );
};

export default Views;
